import { useContext } from 'react';
import { AnalyticsContext } from '../../providers/AnalyticsProvider';

export default function useAnalytics() {
  return useContext(AnalyticsContext);
}
